// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1dRwX","name":"Header_name__28Vsb","birthday":"Header_birthday__27Ipl","skeleton":"Header_skeleton__351ge"};